/**
 * 控制区域 GpNo 编码：4 字节 hex，如 gpno 10 → FFFF000A
 * 结构：FFFF(2字节) + gpNo低16位(2字节)
 *
 * 区域树 Gpno 为完整值，如 4294901789 = 0xFFFF001D，低 16 位与配置值一致
 */
const AREA_GPNO_PREFIX = 0xFFFF0000

export function getAreaGpNoLowBits(gpNo) {
  const num = Number(gpNo)
  if (!Number.isFinite(num)) return null
  return num & 0xFFFF
}

export function isSameAreaGpNo(gpNoA, gpNoB) {
  const lowA = getAreaGpNoLowBits(gpNoA)
  const lowB = getAreaGpNoLowBits(gpNoB)
  return lowA != null && lowB != null && lowA === lowB
}

export function encodeAreaGpNoToConfigValue(gpNo) {
  const lowBits = getAreaGpNoLowBits(gpNo)
  if (lowBits == null || lowBits < 0) return ''
  const hex = lowBits.toString(16).toUpperCase().padStart(4, '0')
  return `FFFF${hex}`
}

/**
 * 从 SetConfig / param DefaultValue 解码区域 gpno（十六进制低 16 位 → 十进制）
 * 例：FFFF001D → 29，FFFF000B → 11
 */
export function decodeAreaGpNoFromConfigValue(value) {
  if (value === null || value === undefined || value === '') return null
  const str = String(value).trim().toUpperCase()
  if (!str) return null

  if (str.startsWith('FFFF') && str.length >= 8) {
    const gpNo = parseInt(str.slice(-4), 16)
    return Number.isFinite(gpNo) ? gpNo : null
  }

  if (/^[0-9A-F]+$/.test(str) && str.length >= 4) {
    const gpNo = parseInt(str.slice(-4), 16)
    return Number.isFinite(gpNo) ? gpNo : null
  }

  const gpNo = Number(str)
  return Number.isFinite(gpNo) ? getAreaGpNoLowBits(gpNo) : null
}

/**
 * 配置低 16 位 → 区域树完整 Gpno（0xFFFF0000 | lowBits）
 */
export function toTreeAreaGpNo(gpNo) {
  const lowBits = getAreaGpNoLowBits(gpNo)
  if (lowBits == null) return null
  return AREA_GPNO_PREFIX | lowBits
}

export function findAreaNodeInTree(list, gpNo) {
  if (!Array.isArray(list)) return null

  for (const item of list) {
    const nodeGpNo = item.Gpno ?? item.id
    if (isSameAreaGpNo(nodeGpNo, gpNo)) {
      return item
    }

    const children = item.Childs || item.children
    const child = findAreaNodeInTree(children, gpNo)
    if (child) return child
  }

  return null
}

export function findGpDetail(gpList, { GpNo, GpKeyId }) {
  if (!Array.isArray(gpList) || !GpNo || GpKeyId === undefined) return null;
  const gp = gpList.find(item => String(item.GpNo) === String(GpNo));
  return gp?.GpDetails?.find(detail => String(detail.KeyId) === String(GpKeyId)) || null;
}

export function resolveParentGpNo(device) {
  const deviceParentGpnos = (device?.ParentGpnos || '').replace(/^@+|@+$/g, '').split('@,@');
  const parentGpNo = Number(deviceParentGpnos[1]);
  return Number.isInteger(parentGpNo) ? parentGpNo : null;
}
